module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.65df5dbc.png";